import { environment } from 'src/environments/environment';

export class ApiCore {
  public static BASE_URL = environment.baseUrl;
  // Authentication
  public static AUTH = 'auth/';
  public static LOGIN = 'login/';
  public static LOGOUT = 'logout';
  public static SIGNIN = 'signin/';
  public static SIGNIUP = 'signup/';
  public static VERIFY = 'verify/';
  public static VERIFY_TOKEN_EXPIRATION = 'verify-expiration/';
  public static USER = 'user';
  public static OPERATOR = 'operator';
  public static RECOVER_PASSWORD = 'password-reset-request';
  public static RESET_PASSWORD = 'password-reset';
  public static RESER_PASSWORD_ONLY = 'password-reset-only';
  public static DUPLICATED_PASSWORD = 'validate-current-password';
  public static USER_UPLOAD_PERSONAL_ID = 'user/upload-personal-id';
  public static USER_UPLOAD_IMAGE_PROFILE = 'user/upload-profile-img';
  public static LOBBY_OPEN_GAMES = 'lobby-open/games';
  public static CATEGO_GAMES = 'game/get-categories-games';
  public static LOBBY_CATEGORY_GAMES = 'game/games-by-category';
  public static LOBBY_ALL_GAMES = 'game/all-games';
  public static LOBBY_ALL_GAMES_v2 = 'game/all-games/v2';
  public static ACTIVATE_GAMES = 'game/active-games';
  public static LOBBY_CATEGORY_GAMES_BASIC = 'game/games-by-category-basic';
  public static LOBBY_OPEN_SECTIONS = 'lobby-open/custom-sections/';
  public static LOBBY_OPEN_BANNERS = 'lobby-open/banners/';
  public static ENTER_GAMES = 'game/enterGame/';
  public static SESSION_GAMES = 'game-session/user-session';
  public static CATALOGS = 'catalogs/';
  public static EMAIL_AVAILABLE = 'email-availability/';
  public static USER_AVAILABLE = 'user-name-availability/';
  public static LOBBY_GAME_CAT = 'lobby-open/game-categories';
  public static LOBBY_PUBLIC_GAME_CAT = 'lobby-open/public-game-categories';
  public static GAME_FEATURED = 'game/featured-games';
  public static LOBBY_COUNT_CAT = 'lobby-open/category-count';
  public static LOBBY_GAME_VENDORS = 'lobby-open/game-vendors';
  public static PC_PLAYER = 'pc-players';
  public static LOBBY_SLIDERS = 'lobby-open/sliders';
  public static LOBBY_SUPPLIERS = 'lobby-open/suppliers';
  public static LOBBY_SUPPLIERS_GAMES = 'lobby-open/suppliers-games';
  public static LOBBY_GET_CATEGORY_SUPPLIERS = 'lobby-open/suppliers-category';

  // Generic API
  public static API = 'user';
  public static API_VERSION = '';
  // Special services API
  public static SPECIAL = '';
}
